/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import * as S from './styles';
import './styles.css';

export interface IBlurBackgroundProps {
  backgroundImage: string;
  imageStyle: any;
  width?: string;
  height?: string;
  children: any;
  onClick?: () => void;
}

const getImageStyle = S.getImageStyle;

export const BlurBackground = ({
  backgroundImage,
  imageStyle,
  width,
  height,
  children,
  onClick,
}: IBlurBackgroundProps) => {
  return (
    <div
      style={{
        ...S.MainContainerStyle(backgroundImage, width, height),
        ...imageStyle,
      }}
      onClick={onClick}
    >
      <div className="image-background" style={S.ImageBackgroundStyle}>
        {children}
      </div>
    </div>
  );
};

export { getImageStyle };

BlurBackground.defaultProps = {};
